import React from 'react';
import { Button } from '@heroui/react';
import { Wrapper, Hyperlink } from './buttonsCSS';

const Buttons = ({ childrenList }) => {
  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <Wrapper onClick={stopPropagation} onMouseDown={stopPropagation}>
      {childrenList.map((child) => (
        <>
          {
            {
              button: (
                <Button
                  radius="full"
                  className="min-w-16 h-8 text-xs"
                  color={
                    child.text.toLowerCase() === 'proceed'
                      ? 'primary'
                      : 'default'
                  }
                  key={child.dataTestId}
                  data-testid={child.dataTestId}
                  onPress={child.triggerFunction}
                >
                  {child.text}
                </Button>
              ),
              link: (
                <>
                  <Hyperlink
                    href={child?.link}
                    target={child?.link && '_blank'}
                    key={child.dataTestId}
                  >
                    <Button
                      radius="full"
                      className="min-w-16 h-8 text-xs"
                      color={
                        child.text.toLowerCase() === 'open'
                          ? 'primary'
                          : 'default'
                      }
                      data-testid={child.dataTestId}
                      onClick={child.triggerFunction}
                    >
                      {child.text}
                    </Button>
                  </Hyperlink>
                </>
              ),
            }[child.type]
          }
        </>
      ))}
    </Wrapper>
  );
};

export default Buttons;
